// paths
import {
  CREATE_WORKSPACE,
  ONBOARDING,
  PROFILE,
  PROJECT,
  PROJECTS,
  SETTINGS,
  UNAUTHORIZED_WORKSPACE_ACCESS,
  USERS,
  WORKSPACE_INVITE_LOGIN,
} from '../../constants/routes';

// pages
import ProjectList from '../../pages/Projects/List/index';
import ProjectDetail from '../../pages/Projects/Detail';
import Team from '../../pages/User/UserList';
import WorkspaceCreation from '../../domain/workspaces/new';
import UserOnboarding from '../../domain/user-onboarding';
// Roles
import { SUPER_ADMIN, ADMIN, EMPLOYEE } from '../../constants/roles';
import WorkspaceSettings from '../../domain/workspaces/edit';
import WorkspaceProfileSettings from '../../domain/workspaces/profile/edit';
import AuthError from '../../pages/Error/auth-error';
import WorkspaceLogin from '../../pages/Login';

export const userRoutes = [
  {
    path: `/${WORKSPACE_INVITE_LOGIN}`,
    name: 'Workspace Invite',
    element: <WorkspaceLogin />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${ONBOARDING}`,
    name: 'Onboarding',
    element: <UserOnboarding />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${CREATE_WORKSPACE}`,
    name: 'Workspace',
    element: <WorkspaceCreation />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${UNAUTHORIZED_WORKSPACE_ACCESS}`,
    name: 'Unauthorized',
    element: <AuthError />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
];

export const workspaceRoutes = [
  {
    path: '/',
    name: 'Projects',
    element: <ProjectList />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${PROJECTS}`,
    name: 'Projects',
    element: <ProjectList />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${PROJECT}/:id`,
    name: 'Project',
    element: <ProjectDetail />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${SETTINGS}`,
    name: 'Workspace Settings',
    element: <WorkspaceSettings />,
    isAllowed: [SUPER_ADMIN, ADMIN],
  },
  {
    path: `/${PROFILE}`,
    name: 'Workspace Profile',
    element: <WorkspaceProfileSettings />,
    isAllowed: [SUPER_ADMIN, ADMIN, EMPLOYEE],
  },
  {
    path: `/${USERS}`,
    name: 'Users',
    element: <Team />,
    isAllowed: [SUPER_ADMIN, ADMIN],
  },
];
